module.exports = __webpack_public_path__ + "static/media/file-spreadsheet.8649c684.svg";